import React, { useState } from "react";
import styled from "@emotion/styled";
import UserImage from "@components/item/UserImage";
import { useTranslation } from "react-i18next";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";
import StarRating from "@components/item/StarRating";
import { useNavigate } from "react-router-dom";
import { useApiRequest } from "@utils/ApiRequest";
import { useQuery } from "@tanstack/react-query";

const Container = styled.div<{ button?: boolean }>(({ button, theme }) => ({
  position: "relative",
  display: "flex",
  gap: "1rem",
  alignItems: "flex-start",
  border: button ? `1px solid ${theme.color.border_gray}` : "none",
  padding: button ? "1rem" : "",
}));

const InfoWrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
});

const Membership = styled.div(({ theme }) => ({
  display: "inline-block",
  fontSize: "1rem",
  lineHeight: "1.2rem",
  color: theme.color.black,
  backgroundColor: theme.color.mint,
  padding: "0.6rem 0.8rem",
  borderRadius: "0.4rem",
}));

const NicknameBox = styled.div<{ button?: boolean }>(({ theme, button }) => ({
  display: "flex",
  alignItems: button ? "flex-end" : "center",
  gap: "1rem",
  fontSize: "1.6rem",
  fontWeight: theme.fontWeight.medium,
  lineHeight: "2.4rem",

  ".sell_count": {
    color: "#969696",
    fontWeight: theme.fontWeight.regular,
    fontSize: "1.2rem",
    lineHeight: "2rem",
  },
}));

const Email = styled.span(({ theme }) => ({
  color: theme.color.light_gray,
  fontWeight: theme.fontWeight.medium,
}));

const EditButton = styled.button({
  display: "flex",
});

const UserInfoCard = ({ myPage }: { myPage?: boolean; button?: boolean }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();

  const { getUserInfo, getMemberSubscription } = useApiRequest();

  const { data: userInfo, isLoading: userLoading } = useQuery({
    queryKey: ["userInfo"],
    queryFn: getUserInfo,
  });

  const { data: subscribeDetail } = useQuery({
    queryKey: ["subscribeDetail"],
    queryFn: getMemberSubscription,
  });

  const handleNavigatePage = (route: string) => {
    navigate(route);
  };

  return userLoading ? (
    <></>
  ) : (
    <Container>
      <UserImage src={userInfo?.profile_image} />
      <InfoWrapper>
        <NicknameBox>
          {!!subscribeDetail?.is_subscribed && myPage && (
            <Membership>{t("회원")}</Membership>
          )}

          {userInfo?.nickname}

          {myPage && (
            <EditButton
              onClick={() => {
                navigate("/profile-edit");
              }}>
              <Image
                src={theme.image.edit_icon.default}
                width="2rem"
                height="2rem"
              />
            </EditButton>
          )}
        </NicknameBox>

        {myPage && <Email>{userInfo?.login_id}</Email>}

        <StarRating
          rate={userInfo?.rate}
          readonly
          reviewCnt={userInfo?.review_count}
          onClick={() => handleNavigatePage(`/review/${userInfo.id}`)}
        />
      </InfoWrapper>
    </Container>
  );
};

export default UserInfoCard;
